// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__LFwRX","radio":"Checkbox_radio__6f+61","checkboxFlex":"Checkbox_checkboxFlex__gspEe","label":"Checkbox_label__CU7Ko"};